
export enum LicensesType {
  BASIC = 'BASIC',
  PREMIUM = 'PREMIUM'
}

export enum PlanVariant {
  LICENSE = "LICENSE",
  ADDON_SCREEN = "ADDON_SCREEN",
}

export enum ITaxType {
  INCLUSIVE = "INCLUSIVE",
  EXCLUSIVE = "EXCLUSIVE",
}

export enum PlanBillingCycle {
  MONTHLY = "MONTHLY",
  ANNUALLY = "ANNUALLY",
}